query UsersForAccountIndex(
  $id: ID!
  $first: Int
  $last: Int
  $after: String
  $before: String
  $query: String
  $queryList: [QueryItemInput!]
) {
  usersForAccount(
    accountId: $id
    first: $first
    last: $last
    after: $after
    before: $before
    query: $query
    queryList: $queryList
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    edges {
      cursor
      node {
        id
        insertedAt
        updatedAt
        name
        first_name
        last_name
        email
        account {
          id
          name
        }
        role {
          id
          name
        }
      }
    }
  }
}
